<header class="landing-page-header">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <app-navbar></app-navbar>
      </div>
    </div>
    <div class="row header-content">
      <div class="col-xl-6 d-lg-block d-none mb-md-4">
        <div class="mobile-slider">
          <div class="img-slider">
            <owl-carousel-o [options]="customOptions">
              <ng-container *ngFor="let item of images">
                <ng-template carouselSlide>
                  <div class="item">
                    <img [src]="item.image" alt="Image" />
                  </div>
                </ng-template>
              </ng-container>
            </owl-carousel-o>
          </div>
          <img class="header-image" src="../../../assets/images/header-img-frame.png" alt="">
        </div>
      </div>
      <div class="col-xl-6 col-sm-12 p-md-0">
        <div class="subscribe-container">
          <h1 class="hidaya-heading">{{ "HIDAYA_HAEDING" | translate }}</h1>
          <h3 class="hidaya-text">{{ "HIDAYA_TEXT" | translate }}</h3>

          <app-anti-fraud></app-anti-fraud>


        </div>
      </div>
    </div>
  </div>
</header>

<section id="about_hidaya" class="about-hidaya">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-xl-6 offset-xl-3">
        <h1>{{ "ABOUT_HIDAYA_TITLE" | translate }}</h1>
        <h2>
          <span class="bold">{{ "HIDAYA" | translate }}</span>
          {{ "ABOUT_HIDAYA_TEXT" | translate }}
        </h2>
      </div>
      <div class="col-sm-12 col-xl-6 d-xl-block d-none">
        <img src="../../../assets/images/about-us.png" alt="" class="about-us-img">
      </div>
      <div class="col-sm-12 col-xl-6">
        <div class="row">
          <div class="col-sm-12 col-md-6 p-2 d-flex align-items-center " *ngFor="let feature of featuresList">
            <div class="feature-card">
              <img [src]="'../../../assets/images/' + feature.iconName" alt="">
              <div class="text-content">
                <h3 class="feature-title">
                  {{ translate.currentLang == "en"? feature.titleEn : feature.titleAr }}
                </h3>
                <span class="feature-desc">{{translate.currentLang == "en"? feature.descriptionEn :
                  feature.descriptionAr}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section id="available_packages" class="packages">
  <div class="container">
    <div class="row">
      <div class="col-sm-12 col-xl-6 media">
        <img src="../../../assets/images/packages-img.png" alt="" class="packages-img">
        <div class="app-links">
          <a href="https://apps.apple.com/eg/app/hidaya-libya/id6742405750?l=ar" target="_blank">
            <img src="../../../assets/images/app-store.png" alt="">
          </a>

          <a href="https://play.google.com/store/apps/details?id=com.hidayalibya&hl=en" target="_blank">
            <img src="../../../assets/images/google-play.png" alt="">
          </a>
        </div>
      </div>
      <div class="col-md-12 col-xl-6 content">
        <div class="row text-sm-center">
          <div class="col-12">
            <h3 class="packages-title">
              {{ "AVAILABLE_PACKAGES" | translate }}
            </h3>
          </div>
          <div class="col-12">
            <span class="packages-note">
              {{ "PACKAGES_NOTE" | translate }}
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-12 mb-2">
            <span class="madar-title">
              {{ "LIBYANA" | translate }}
            </span>
          </div>
          <ng-container *ngFor="let package of allPackages.libyana; let i = index">
            <div class="col-sm-12 col-md-6">
              <div class="package-card">
                <div class="package-data">
                  <img src="../../../assets/images/package-icon.svg" alt="">
                  <h3 class="package-name">
                    {{ translate.currentLang == "en" ? package.nameEn : package.nameAr }}
                  </h3>
                  <h4 class="package-price">
                    <span class="number-text">{{ package.price }}</span>
                    {{ package.currency| translate }}
                  </h4>
                </div>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="row">
          <div class="col-12 mb-2">
            <span class="madar-title">
              {{ "MARAD_TITLE" | translate }}
            </span>
          </div>
          <ng-container *ngFor="let package of allPackages.elmadar">
            <div class="col-sm-12 col-md-12">
              <div class="package-card">
                <div class="package-data">
                  <img src="../../../assets/images/package-icon.svg" alt="">
                  <h3 class="package-name">
                    {{ translate.currentLang == "en" ? package.nameEn : package.nameAr }}
                  </h3>
                  <h4 class="package-price">
                    <span class="number-text">{{ package.price }}</span>
                    {{ package.currency| translate }}
                  </h4>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</section>

<section id="faq" class="faq">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h3 class="faq-title">
          {{ "FAQ_TITLE" | translate }}
        </h3>
      </div>
      <div class="col-12">
        <span class="faq-note">
          {{ "FAQ_NOTE" | translate }}
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <p-panel [toggleable]="true" iconPos="end" [collapsed]="isCollapsed1">
          <ng-template pTemplate="header">
            <div class="flex align-items-center gap-2" [ngClass]="{'all-border-rounded': isCollapsed1}">
              <h1>{{ "FAQ_Q1" | translate }}</h1>
            </div>
          </ng-template>
          <ng-template pTemplate="content">
            <div class="flex flex-wrap align-items-center justify-content-between gap-3">
              {{ "FAQ_A1" | translate }}
            </div>
          </ng-template>
          <ng-template pTemplate="headericons">
            <button class="p-panel-header-icon p-link mr-2" (click)="isCollapsed1 = !isCollapsed1">
              <img src="../../../assets/images/collapse-icon.svg" alt="" style="width: 100%;"
                [ngClass]="{'rotate-image': isCollapsed1}">
            </button>
          </ng-template>
        </p-panel>
      </div>
      <div class="col-12">
        <p-panel [toggleable]="true" iconPos="end" [collapsed]="isCollapsed2">
          <ng-template pTemplate="header">
            <div class="flex align-items-center gap-2" [ngClass]="{'all-border-rounded': isCollapsed2}">
              <h1>{{ "FAQ_Q2" | translate }}</h1>
            </div>
          </ng-template>
          <ng-template pTemplate="content">
            <div class="flex flex-wrap align-items-center justify-content-between gap-3">
              <ol>
                <li>{{ "WEBSITE_SUBSCRIPE1" | translate }}</li>
                <li>{{ "MOBILE_SUBSCRIPE" | translate }}</li>
              </ol>
              <span>{{ "MOBILE_SUBSCRIPE_CODES" | translate }}</span>
              <span class="instructions-list-title">{{ "MOBILE_SUBSCRIPE_LIBYANA_CODES" | translate }}</span>
              <ol>
                <li>{{ "MOBILE_SUBSCRIPE_LIBYANA_CODES_1" | translate }}</li>
                <li>{{ "MOBILE_SUBSCRIPE_LIBYANA_CODES_2" | translate }}</li>
              </ol>

              <span class="instructions-list-title">{{ "MOBILE_SUBSCRIPE_ALMADAR_CODES" | translate }}</span>
              <ol>
                <li>{{ "MOBILE_SUBSCRIPE_ALMADAR_CODES_1" | translate }}</li>
              </ol>

              <ul class="m-4">
                <li>{{ "MOBILE_UNSUBSCRIPE_CODE" | translate }}</li>
                <li>{{ "MOBILE_HELP_CODE" | translate }}</li>
              </ul>
            </div>
          </ng-template>
          <ng-template pTemplate="headericons">
            <button class="p-panel-header-icon p-link mr-2" (click)="isCollapsed2 = !isCollapsed2">
              <img src="../../../assets/images/collapse-icon.svg" alt="" style="width: 100%;"
                [ngClass]="{'rotate-image': isCollapsed2}">
            </button>
          </ng-template>
        </p-panel>
      </div>
      <div class="col-12">
        <p-panel [toggleable]="true" iconPos="end" [collapsed]="isCollapsed3">
          <ng-template pTemplate="header">
            <div class="flex align-items-center gap-2" [ngClass]="{'all-border-rounded': isCollapsed3}">
              <h1>{{ "FAQ_Q3" | translate }}</h1>
            </div>
          </ng-template>
          <ng-template pTemplate="content">
            <div class="flex flex-wrap align-items-center justify-content-between gap-3">
              <span>{{ "UNSUBSCRIPE_INSTRUCTIONS_HEADER" | translate }}</span>
              <span class="instructions-list-title">{{ "UNSUBSCRIPE_INSTRUCTIONS_WEB" | translate }}</span>
              <ul>
                <li>{{ "WEBSITE_UNSUBSCRIPE1" | translate }}</li>
              </ul>

              <span class="instructions-list-title">{{ "UNSUBSCRIPE_INSTRUCTIONS_NUMBER" | translate }}</span>
              <ul>
                <li>{{ "NUMBER_UNSUBSCRIPE1" | translate }}</li>
              </ul>
            </div>
          </ng-template>
          <ng-template pTemplate="headericons">
            <button class="p-panel-header-icon p-link mr-2" (click)="isCollapsed3 = !isCollapsed3">
              <img src="../../../assets/images/collapse-icon.svg" alt="" style="width: 100%;"
                [ngClass]="{'rotate-image': isCollapsed3}">
            </button>
          </ng-template>
        </p-panel>
      </div>
      <div class="col-12">
        <p-panel [toggleable]="true" iconPos="end" [collapsed]="isCollapsed4">
          <ng-template pTemplate="header">
            <div class="flex align-items-center gap-2" [ngClass]="{'all-border-rounded': isCollapsed4}">
              <h1>{{ "FAQ_Q4" | translate }}</h1>
            </div>
          </ng-template>
          <ng-template pTemplate="content">
            <div class="flex flex-wrap align-items-center justify-content-between gap-3">
              {{ "FAQ_A4" | translate }}
            </div>
          </ng-template>
          <ng-template pTemplate="headericons">
            <button class="p-panel-header-icon p-link mr-2" (click)="isCollapsed4 = !isCollapsed4">
              <img src="../../../assets/images/collapse-icon.svg" alt="" style="width: 100%;"
                [ngClass]="{'rotate-image': isCollapsed4}">
            </button>
          </ng-template>
        </p-panel>
      </div>
    </div>
  </div>
</section>

<section class="privacy-policy">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="privacy-policy-details">
          <div class="overlay"></div>
          <div class="row position-relative z-index-2">
            <div class="col-12 d-flex justify-content-center flex-column align-items-center">
              <h3 class="title">{{ "CONTACT_US_TITLE" | translate }}</h3>
              <span class="text">{{ "PRIVACY_POLICY_TEXT1" | translate }}</span>
              <span class="contact-mail pt-2">{{ "info@hidaya.me" }}</span>
              <span class="text pt-4">{{ "PRIVACY_POLICY_TEXT2" | translate }}</span>
              <div class="icons pt-4">
                <a (click)="openLink('https://www.facebook.com/share/15TcFc8yWP/')">
                  <img src="../../../assets/images/facebook-fill.png" alt="">
                </a>

                <a (click)="openLink('https://www.instagram.com/hidayaapp/')">
                  <img src="../../../assets/images/instagram-fill.png" alt="">
                </a>

                <a (click)="openLink('https://www.youtube.com/@hidaya-app')">
                  <img src="../../../assets/images/youtube-fill.png" alt="">
                </a>

                <a (click)="openLink('https://x.com/HidayaInfo?t=g09BDia3cd_tatVcqW2mvA&s=09')">
                  <img src="../../../assets/images/twitter-x.png" alt="">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>